import { createSelector } from "reselect";

import { transformDashboardStats } from "../../models/dashboard";

export const getDashboard = state => state.ui.dashboard;

export const getDashboardStats = createSelector(getDashboard, ({ stats }) =>
  transformDashboardStats(stats)
);
